import React, { useState } from 'react';
import '../css/searchField.css';
import { SearchFieldSearchIcon } from '../../../../../asset-controller-mod/asset-serv/icons/iconExporter';


export interface SearchFieldProps {
  id?: string;
  name?: string;
  value?: string;
  placeholder?: string;
  label?: string;
  onChange?: (value: string) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  error?: boolean;
  errorText?: string;
  warning?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({
  id,
  name,
  value = '',
  placeholder = 'Search',
  label,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  className = '',
  error = false,
  errorText,
  warning = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const displayLabel = label || placeholder;
  const hasValue = value && value.length > 0;
  const showFloatingLabel = isFocused || hasValue;

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div className={`scl--cms-components-searchField-container ${className}`}>
      <div
        className={`scl--cms-components-searchField-plate ${error ? 'scl--cms-components-searchField--error' : ''} ${warning ? 'scl--cms-components-searchField--warning' : ''} ${disabled ? 'scl--cms-components-searchField--disabled' : ''} ${isFocused ? 'scl--cms-components-searchField--focused' : ''}`}
      >
        {/* Floating Label */}
        {displayLabel && (
          <label className={`scl--cms-components-searchField-label ${showFloatingLabel ? 'scl--cms-components-searchField-label--floating' : ''}`}>
            {displayLabel}
          </label>
        )}

        <div className="scl--cms-components-searchField-wrapper">
          {!isFocused && !hasValue && <SearchFieldSearchIcon className="scl--cms-components-searchField-icon" />}
          
          <input
            id={id}
            name={name}
            type="text"
            value={value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}
            className="scl--cms-components-searchField-input"
            autoComplete="off"
          />
        </div>
      </div>

      {errorText && error && (
        <div className="scl--cms-components-searchField-errorText">
          {errorText}
        </div>
      )}
    </div>
  );
};

export default SearchField;